<template>
  <div class="container_box">
    <div class="light_box">
      <img
        class="screan"
        src="../assets/img/light/screan.png"
        v-if="!isLight"
        alt=""
      />
      <img class="screan" src="../assets/img/light/isliaght.png" v-else alt="" />
      <img class="tou" src="../assets/img/light/tou.png" alt="" />
      <img class="ai" src="../assets/img/light/ai.png" alt="" />
      <img class="light" src="../assets/img/light/light.png" alt="" />
    </div>
    <el-button
      class="light_button"
      type="primary"
      @click="translationStart"
      v-if="vS"
      >开始</el-button
    >
    <el-button
      class="light_button"
      type="primary"
      @click="translationEnd"
      v-else
      >停止</el-button
    >
  </div>
</template>

<script>
import IatRecorder from "@/common/IatRecorder";
export default {
  data() {
    return {
      vS: true,
      isLight: false,
      iatRecorder: null,
      voiceText: "",
    };
  },
  methods: {
    translationStart() {
      this.voiceText = "";
      this.vS = false;
      this.iatRecorder.start(this.cancel, this.getVoiceText);
    },
    translationEnd() {
      this.iatRecorder.onTextChange = (text) => {
        let inputText = text;
        var searchData = inputText.substring(0, inputText.length - 1); //文字处理，因为不知道为什么识别输出的后面都带‘。’，这个方法是去除字符串最后一位
        this.getVoiceText(text);
        // console.log(searchData);
      };
      this.iatRecorder.stop();
      this.vS = true;
    },
    getVoiceText(text) {
      //   this.voiceText = text.substring(0, inputText.length - 1);
      this.voiceText = text.split("。")[0];
      if (this.voiceText == "") {
        return;
      }
      if (this.voiceText == "开灯") {
        this.isLight = true;
      } else if (this.voiceText == "关灯") {
        this.isLight = false;
      }
      console.log(this.voiceText);
    },
    cancel() {
      this.vS = true;
    },
  },
  mounted() {
    this.iatRecorder = new IatRecorder("zh_cn", "mandarin", "5ff2d877"); //小语种-中文方言-appId
  },
};
</script>

<style>
.container_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.light_box {
  position: relative;
  width: 414px;
  height: 544px;
}
.screan {
  position: absolute;
  left: 115px;
  top: 53px;
  z-index: 2;
}
.tou {
  position: absolute;
  left: 191px;
  bottom: 5px;
  z-index: 2;
}
.ai {
  position: absolute;
  left: 107px;
  top: 53px;
}
.light {
  position: absolute;
}
.light_button {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/functionLight.vue